<template>
  <div class="ui-block">
    <article class="hentry post">
      <div class="ui-block-title">
        <div v-if="categories && categories.length ">
          <div
            v-for="cat in categories"
            :key="cat.id"
            style="color: #fff; padding: 15px; margin-bottom: 5px; display: inline-block; font-size: 10px; font-weight: bold; margin-right: 5px;"
            :style="{backgroundColor: cat.color}"
          >
            {{ cat.name }}: {{ cat.cumulated_amount.toLocaleString() }} RON
          </div>
        </div>
        <add-financial-eco />
        <div class="control-block-button">
          <a
            href="#"
            class="btn btn-control bg-breez"
            @click="$modal.show('add-financial-eco', {item: {cat_id: '', date: date1 }})"
          >
            <app-icon
              name="olymp-plus-icon"
              color="white"
              size="normal"
            />
          </a>
        </div>
      </div>

      <br>
      <br>
      <table
        v-if="items && items.length"
        style="width:100%"
        class="shop_table cart"
      >
        <thead>
          <tr>
            <th class="product-date">
              DATE
            </th>
            <th class="product-description">
              ITEM DESCRIPTION
            </th>
            <th class="product-price">
              AMOUNT
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
            class="cart_item"
          >
            <td
              class="product-date"
              style="min-width: 90px;"
            >
              <span>{{ Object.keys(item)[0] }}</span>
            </td>
            <td class="product-description">
              <div
                v-for="message in item[Object.keys(item)[0]]"
                :key="message.id"
                class="cart-product-content"
                style="padding-right: 10px;"
              >
                <h6 class="cart-product-title">
                  <div
                    style="width: 10px; height:10px; display: inline-block; margin-right: 5px;"
                    :style="{ 'background-color': message.FiCatEco.color }"
                  />{{ message.description }}
                </h6><br>
              </div>
            </td>
            <td
              class="product-price"
              style="min-width: 100px"
            >
              <div
                v-for="message in item[Object.keys(item)[0]]"
                :key="message.id"
              >
                <h6 class="price amount">
                  {{ message.amount }} RON
                </h6>
                <a
                  href="#"
                  style="margin-left: 15px;"
                  @click="$modal.show('add-financial-eco', { item: message })"
                >
                  <app-icon
                    name="olymp-three-dots-icon"
                    color="gray"
                    size="normal"
                  />
                </a>
                <br>
              </div>
            </td>
          </tr>
        <!--<tr>-->
          <!--<td colspan="3" class="actions">-->
          <!--<div style="font-size: 16px;" class="cart-subtotal">Personal Subtotal:<span class="total-personal">{{subtotal_personal}} RON</span></div>-->
          <!--</td>-->
        <!--</tr>-->
        <!--<tr>-->
          <!--<td colspan="3" class="actions">-->
          <!--<div style="font-size: 16px;" class="cart-subtotal">Business Subtotal:<span class="total-business">{{subtotal_business}} RON</span></div>-->
          <!--</td>-->
        <!--</tr>-->
        <!--<tr>-->
          <!--<td colspan="3" class="actions">-->
          <!--<div style="font-size: 24px;" class="cart-subtotal">Total:<span class="total">{{subtotal_personal + subtotal_business}} RON</span></div>-->
          <!--</td>-->
        <!--</tr>-->
        </tbody>
      </table>
    </article>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import AddFinancialEco from './AddFinancialEco'
import AppIcon from "../../common-apps/common/AppIcon"
import financialStore from '../../../store/modules/personal/financial'

export default {
  name: 'FinancialTable',
  components: { AddFinancialEco, AppIcon },
  props: {
    date: {
      type: Date,
      default: function () { return {} }
    }
  },
  data () {
    return {
      date1: new Date()
    }
  },
  computed: mapState({
    items: state => state.financial ? state.financial.itemseco : [],
    // subtotal_personal: state => state.financial.subtotal_personal,
    // subtotal_business: state => state.financial.subtotal_business,
    categories: state => state.financial ? state.financial.cateco : []
  }),
  created () {
    if (!this.$store.hasModule('financial')) {
      this.$store.registerModule('financial', financialStore)
    }
    this.$store.dispatch('financial/getCatEco', Vue.prototype.$currentYear)
  },
  activated () {
    this.$store.dispatch('financial/getCurrentEco', { date: this.date })
  },
  beforeDestroy () {
    this.$store.unregisterModule('financial')
  },
  methods: {}
}
</script>
